var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-dialog',{attrs:{"dialog":_vm.dialog}},[_c('div',{staticClass:"repetition-audio-select-course-dialog"},[_c('RepetitionAudioCourses',{on:{"close":_vm.close}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }